import {Ship} from 'lucide-react'
import { Link } from 'react-router-dom'

const COLUMNS = [
  { title: 'Modes', links: ['LTL Shipping', 'Full Truckload', 'Ocean Freight', 'Air Freight'] },
  { title: 'Company', links: ['About', 'Carrier Network', 'Coverage', 'Contact'] },
  { title: 'Resources', links: ['Rate Guide', 'Freight Class', 'Accessorials', 'FAQ'] },
]

function Footer() {
  return (
    <footer className="bg-[#0F172A] text-slate-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-[#10B981] text-white">
                <Ship className="w-5 h-5" />
              </span>
              <span className="text-white font-bold">The Freight Calculator</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed">
              Instant B2B freight estimates and firm carrier rates across LTL, truckload, ocean, and air.
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#calculator" className="text-sm hover:text-[#10B981] transition-colors">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
          <span>&copy; {new Date().getFullYear()} The Freight Calculator. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <span>www.thefreightcalculator.com</span>
            <Link to="/admin" className="hover:text-[#10B981] transition-colors">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
